export default {"src":"/_next/static/media/long-sleeves.d9e97599.svg","height":168,"width":240,"blurWidth":0,"blurHeight":0};